import { render, staticRenderFns } from "./AssignedFreelancer.vue?vue&type=template&id=202ae3d0&"
import script from "./AssignedFreelancer.vue?vue&type=script&lang=js&"
export * from "./AssignedFreelancer.vue?vue&type=script&lang=js&"
import style0 from "./AssignedFreelancer.vue?vue&type=style&index=0&id=202ae3d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports